module.exports = __webpack_public_path__ + "static/media/instagram-container-nick.cc95ab47.svg";